var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 24.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff6500;}.cls-2{fill:#cac7c7;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Metiri M 40x40") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.8,28.91,30.28,9.22a2.5,2.5,0,0,0-2.92-1.45,2.39,2.39,0,0,0-1.29.88,3.25,3.25,0,0,0-.23.29l-4.17,6.2a2,2,0,0,1-3.36,0l-4.17-6.2a3.25,3.25,0,0,0-.23-.29,2.39,2.39,0,0,0-1.29-.88A2.5,2.5,0,0,0,9.7,9.22L1.21,28.83a2.49,2.49,0,0,0,.91,3.11,2.44,2.44,0,0,0,3.53-1.09L11,18.61a2.06,2.06,0,0,1,3.6-.33l3.33,4.95A2.47,2.47,0,0,0,20,24.3a2.44,2.44,0,0,0,2.1-1.07l3.41-5.07a2,2,0,0,1,3.48.32l5.32,12.3a2.5,2.5,0,0,0,2.87,1.46A2.44,2.44,0,0,0,38.8,28.91Z",
    transform: "translate(-1 -7.69)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19,
    cy: 22.2,
    r: 2.43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSquare);
export default __webpack_public_path__ + "static/media/LogoSquare.c63679aec8954019e4b5315d057b03b7.svg";
export { ForwardRef as ReactComponent };